/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Tooltip_Techsourcesteamdb3Inputs */

const id_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const ms_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const da_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const de_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const en_us2_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const es_es2_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const es_mx2_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const fil_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const fr_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const it_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const hu_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const nl_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const no_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const pl_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const pt_br2_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const pt_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const ro_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const fi_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB:tä`)
};

const sv_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const vi_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const tr_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const cs_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const bg_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const ru_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const uk_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const ar_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const hi_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const th_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const ja_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const zh_cn2_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const zh_hant1_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

const ko_builds_tooltip_techsourcesteamdb3 = /** @type {(inputs: Builds_Tooltip_Techsourcesteamdb3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SteamDB`)
};

/**
* | output |
* | --- |
* | "SteamDB" |
*
* @param {Builds_Tooltip_Techsourcesteamdb3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_tooltip_techsourcesteamdb3 = /** @type {((inputs?: Builds_Tooltip_Techsourcesteamdb3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Tooltip_Techsourcesteamdb3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "ms") return ms_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "da") return da_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "de") return de_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "en-US") return en_us2_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "es-ES") return es_es2_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "es-MX") return es_mx2_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "fil") return fil_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "fr") return fr_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "it") return it_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "hu") return hu_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "nl") return nl_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "no") return no_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "pl") return pl_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "pt-BR") return pt_br2_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "pt") return pt_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "ro") return ro_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "fi") return fi_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "sv") return sv_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "vi") return vi_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "tr") return tr_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "cs") return cs_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "bg") return bg_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "ru") return ru_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "uk") return uk_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "ar") return ar_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "hi") return hi_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "th") return th_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "ja") return ja_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_tooltip_techsourcesteamdb3(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_tooltip_techsourcesteamdb3(inputs)
	return ko_builds_tooltip_techsourcesteamdb3(inputs)
});
export { builds_tooltip_techsourcesteamdb3 as "builds.tooltip.techSourceSteamDb" }